'use strict';

import Type from './Type';

/**
 * @property {string}   id
 * @property {string}   name
 * @property {Type[]} types
 * @property {string}   description
 * @property {boolean}  optional
 * @property {any}      defaultValue
 */
class Parameter {
  /**
   * @param {string}    id
   * @param {string}    name
   * @param {Type[]}  types
   * @param {string}    description
   * @param {boolean}   optional
   * @param {any}       defaultValue
   */
  constructor ( { id, name, types, description, optional, defaultValue } ) {
    this.id           = id;
    this.name         = name;
    this.types        = Object.entries(types).map(( [ name, type ] ) => new Type(name, type));
    this.description  = description;
    this.optional     = optional;
    this.defaultValue = defaultValue;
  }
}

export default Parameter;
